export default "__VITE_ASSET__de0b2ff4__"